import { useEffect, useRef, useState } from 'react';
import { getAlarmRuleErrorMessage } from './filterParameterMapping';

export const useAlarmList = ({ service, isActive, showArchived, toasterService, errorTitle }) => {
  const [items, setItems] = useState([]);
  const [loadBusy, setLoadBusy] = useState(false);
  const [reloadVersion, setReloadVersion] = useState(0);
  const mountedRef = useRef(false);
  const requestRef = useRef(0);
  const loadingRef = useRef(false);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
      requestRef.current += 1;
    };
  }, []);

  useEffect(() => {
    if (!isActive) {
      loadingRef.current = false;
      setLoadBusy(false);
      return;
    }

    const request = ++requestRef.current;
    loadingRef.current = true;
    setLoadBusy(true);
    const load = async () => {
      try {
        const result = await service.list(showArchived);
        if (mountedRef.current && request === requestRef.current) setItems(result);
      } catch (error) {
        if (mountedRef.current && request === requestRef.current) {
          toasterService.error(errorTitle, getAlarmRuleErrorMessage(error, 'Please try again.'));
        }
      } finally {
        if (mountedRef.current && request === requestRef.current) {
          loadingRef.current = false;
          setLoadBusy(false);
        }
      }
    };
    void load();
    return () => {
      requestRef.current += 1;
      loadingRef.current = false;
    };
  }, [service, isActive, showArchived, reloadVersion, toasterService, errorTitle]);

  const reload = () => {
    if (!mountedRef.current) return;
    requestRef.current += 1;
    setReloadVersion(version => version + 1);
  };

  const updateItems = update => {
    if (!mountedRef.current) return;
    setItems(update);
    if (loadingRef.current) reload();
  };

  return { items, loadBusy, reload, updateItems, mountedRef };
};